import { ref, onBeforeUnmount, onMounted } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import { fireTag } from '@vue-util/tagManager';
import { useStore } from 'vuex';
import useFireTagAsync from '@modules/discovery/composables/useFireTagAsync';

const startDate = '05282025'; // 5/28/2025
const endDate = '06252025';// 6/25/2025

export default function useConvoAnalytics(experiment) {
  const targetRef = ref();
  const store = useStore();
  const enableAsyncAnalyticsTags = store?.state?.envProps?.enableAsyncAnalyticsTags;

  function fireImpressions() {
    const utagData = {
      event_name: 'experiment view',
      link_name: 'experiment view',
      experiment_key: `ConversationalFiltering:${experiment}:conversational filtering impression:${startDate}:${endDate}`,
      experiment_key_type: 'condition',
    };

    if (enableAsyncAnalyticsTags) {
      useFireTagAsync(() => fireTag('link', utagData));
    } else {
      fireTag('link', utagData);
    }
  }

  function fireClicks() {
    const utagData = {
      event_name: 'experiment action',
      link_name: 'experiment action',
      experiment_key: `ConversationalFiltering:${experiment}:conversational filtering click:${startDate}:${endDate}`,
      experiment_key_type: 'action',
    };

    if (enableAsyncAnalyticsTags) {
      useFireTagAsync(() => fireTag('link', utagData));
    } else {
      fireTag('link', utagData);
    }
  }

  let observer;
  const isStopped = ref(false);
  onMounted(() => {
    observer = useIntersectionObserver(targetRef, ([entry]) => {
      /* istanbul ignore else */
      if (entry.isIntersecting) {
        fireImpressions();
        observer.stop();
        isStopped.value = true;
      }
    });
  });

  onBeforeUnmount(() => {
    /* istanbul ignore else */
    if (observer && !isStopped.value) {
      observer.stop();
    }
  });

  return {
    fireImpressions,
    fireClicks,
    targetRef,
    isStopped,
  };
}
